import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import * as organisationActions from 'app/ducks/organisations/actions';
import * as teamActions from 'app/ducks/teams/actions';
import * as groupsActions from 'app/ducks/groups/actions';
import * as organisationSectionActions from 'app/ducks/organisationSections/actions';
import * as connectActions from 'app/ducks/connect/actions';

import * as clubsSelectors from 'app/ducks/clubs/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';
import * as usersSelectors from 'app/ducks/users/selectors';
import * as organisationSelectors from 'app/ducks/organisations/selectors';
import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as groupsSelectors from 'app/ducks/groups/selectors';
import * as organisationSectionSelectors from 'app/ducks/organisationSections/selectors';

import {
  ITeamsSelector,
  IOrganisationsSelector,
  IGroupsSelector,
  IOrganisationSectionsSelector,
  IUsersSelector,
  IClubsSelector,
} from 'app/types/selector';
import RenderContent from 'app/components/layout/RenderContent';
import TeamsList from './components/TeamsList';
import MatchPaymentDetail from './components/MatchPaymentDetail';
import CreateTeam from './components/CreateTeam';
import EditTeam from './components/EditTeam';

interface IMatchPaymentsLayoutProps {
  actions: any;
  teams: ITeamsSelector;
  clubs: IClubsSelector;
  users: IUsersSelector;
  organisations: IOrganisationsSelector;
  groups?: IGroupsSelector;
  organisationSections?: IOrganisationSectionsSelector;
  match: any;
  appReady?: boolean;
}

function selector(state): any {
  return {
    teams: teamsSelectors.getTeams(state),
    users: usersSelectors.getUsers(state),
    clubs: clubsSelectors.getClubs(state),
    connect: state.connect,
    organisations: organisationSelectors.getOrganisations(state),
    groups: groupsSelectors.getGroups(state),
    organisationSections: organisationSectionSelectors.getOrganisationSections(
      state,
    ),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  teamActions,
  organisationActions,
  organisationSectionActions,
  groupsActions,
  connectActions,
);

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class MatchPaymentsLayout extends React.Component<
IMatchPaymentsLayoutProps,
{}
> {
  static defaultProps = {
    actions: undefined,
    teams: undefined,
    users: undefined,
    clubs: undefined,
    organisations: undefined,
    groups: undefined,
    organisationSections: undefined,
    appReady: undefined,
    match: undefined,
  };

  async componentDidMount(): Promise<void> {
    if (!this.props.teams.hasLoaded && !this.props.teams.isLoading) {
      await this.props.actions.getAllTeams();
    }
  }

  render(): React.ReactNode {
    return (
      <RenderContent className="my-dashboard-app" match={this.props.match}>
        <Route
          exact
          path="/teams/detail/:teamId"
          render={(): React.ReactNode => (
            <MatchPaymentDetail
              appReady={this.props.appReady}
              match={this.props.match}
            />
          )}
        />
        <Route
          exact
          path="/payment/match/detail/:matchPaymentId"
          render={() => <MatchPaymentDetail {...this.props} />}
        />
      </RenderContent>
    );
  }
}
